import { api } from "./index";

export function getProductVariants(shipInsureId) {
  return api.get("/exchanges/product_variants", {
    params: {
      ship_insure_id: shipInsureId,
    },
  });
}
